import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (props: SVGProps<SVGSVGElement>) => null;
